<template>
  <div class="header q-py-lg">
    <div
      class="absolute-full header-img"
      :src-image="img"
    />
    <div class="container q-px-md">
      <div class="row justify-center">
        <h1 class="col-12 col-md-10 text-center q-mt-xs q-mb-lg text-black">{{
          h1
        }}</h1>
      </div>
    </div>
    <div class="flex full-width justify-center q-px-sm">
      <short-transfer-form
        :type.sync="transferType"
      />
    </div>
  </div>
</template>

<script>
import ShortTransferForm from 'components/ShortTransferForm';

import { TransferForms } from '~mixins';

const { getTransferType } = TransferForms.methods;

export default {
  name: 'MainHeader',
  components: {
    ShortTransferForm,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    imgSrc: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      transferType: this.getTransferType('route', false),
      headerText: this.$t('header.h1'),
    };
  },
  computed: {
    img() {
      if (this.$subdomain?.hasHeaderBg) {
        return `/img/subdomains/${this.$subdomain.name}_bg-header.jpg`;
      }
      return this.imgSrc;
    },
    h1() {
      const isAeroflot = ['aeroflot', 'aeroflotbonus'].includes(this.$subdomain?.name);
      return this.$route.query.h1_title
        || this.title
        || this.headerText[`${this.transferType}_${isAeroflot ? 'aeroflot' : this.$subdomain?.name}`]
        || this.headerText[this.transferType];
    },
  },
  methods: {
    getTransferType,
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  background-position: center;
  background-size: cover;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(#fff, .5);
  }

  h1 {
    position: relative;
    font-size: 30px;
  }

  &-img {
    z-index: -1;
    background-size: cover;
    background-position: 50% 50%;
  }

  .form {
    width: 496px;
  }
}
</style>
